/**
 * The bell's chime (Ray 2026-10-24): a short two-note "ding" when a NEW
 * notification arrives. Made with Web Audio, so there is no sound file to
 * load. The mute switch lives in the bell dropdown and is remembered in this
 * browser only.
 */

const MUTE_KEY = 'smartfi.bellMuted';

export function bellMuted(): boolean {
   try {
      return localStorage.getItem(MUTE_KEY) === '1';
   } catch {
      return false;
   }
}

export function setBellMuted(muted: boolean): void {
   try {
      if (muted) localStorage.setItem(MUTE_KEY, '1');
      else localStorage.removeItem(MUTE_KEY);
   } catch {
      /* private window: the switch still works until reload */
   }
}

/** Chime only when the unread count goes UP after the first load. */
export function shouldChime(prev: number | null, next: number): boolean {
   return prev !== null && next > prev;
}

let ctx: AudioContext | null = null;

export function playChime(): void {
   try {
      const AC = window.AudioContext || (window as any).webkitAudioContext;
      if (!AC) return;
      ctx = ctx ?? new AC();
      if (ctx.state === 'suspended') void ctx.resume();
      const t = ctx.currentTime;
      [880, 1318.5].forEach((freq, i) => {
         const osc = ctx!.createOscillator();
         const gain = ctx!.createGain();
         osc.type = 'sine';
         osc.frequency.value = freq;
         const start = t + i * 0.12;
         gain.gain.setValueAtTime(0.0001, start);
         gain.gain.exponentialRampToValueAtTime(0.25, start + 0.02);
         gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.35);
         osc.connect(gain).connect(ctx!.destination);
         osc.start(start);
         osc.stop(start + 0.4);
      });
   } catch {
      /* the browser blocked audio — the badge still shows */
   }
}
